<template>
  <transition name="slide-fade">
    <v-snackbar
      v-if="currentMessage"
      :key="'message-component-' + MessagesStore.messageCount"
      :value="true"
      bottom
      :timeout="currentMessage.timeout || 5000"
      :color="color"
      @input="MessagesStore.popMessage"
      @click="handleSnackbarClicked"
    >
      <span
        class="d-flex justify-center"
        style="width: 100%"
      >
        <span>
          <span
            class="subtitle-1"
            :class="textColor"
          >
            {{ currentMessage.text }}
          </span>
          <v-btn
            v-if="currentMessage.href"
            class="ml-3 text-none"
            variant="outlined"
            :color="buttonColor"
          >
            <template v-if="currentMessage.hrefText">
              {{ currentMessage.hrefText }}
            </template>
            <template v-else>
              {{ currentMessage.href }}
            </template>
          </v-btn>
        </span>
      </span>
    </v-snackbar>
  </transition>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { Message, Severity } from '@/stores/messages/messages-model';
import MessagesStore from '@/stores/messages/messages-module';

export default defineComponent({
  name: 'SnackbarQueue',
  setup() {
    const currentMessage = computed((): Message | null => MessagesStore.currentMessage);

    const color = computed((): string => {
      switch (currentMessage.value?.severity) {
        case Severity.INFO:
          return 'white';
        case Severity.WARNING:
          return 'warning';
        case Severity.ERROR:
          return 'error';
        case Severity.SUCCESS:
          return 'primary';
      }
      return 'white';
    });

    const textColor = computed((): string => {
      switch (currentMessage.value?.severity) {
        case Severity.WARNING:
        case Severity.ERROR:
        case Severity.SUCCESS:
          return 'white';
      }
      return 'primary';
    });

    const buttonColor = computed((): string => {
      switch (currentMessage.value?.severity) {
        case Severity.WARNING:
        case Severity.ERROR:
        case Severity.SUCCESS:
          return 'white';
      }
      return 'primary';
    });

    const handleSnackbarClicked = (): void => {
      if (currentMessage.value?.href) {
        window.location.assign(currentMessage.value.href);
      }
    };

    return {
      MessagesStore,
      Severity,
      currentMessage,
      color,
      textColor,
      buttonColor,
      handleSnackbarClicked,
    };
  },
});
</script>

<style scoped></style>